import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
    </div>;
}